import React from 'react';
import { observer } from 'mobx-react';
import { autorun, observable } from 'mobx';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import styled from '@emotion/styled';
import Checkbox from 'components/checkbox';
import { isPresent } from '@seedlang/utils';
import { AppUI } from '@seedlang/state';
import WorksheetFilterTags from 'components/worksheet/worksheet_filter_tags';
import { isFunction } from 'lodash';

const Wrapper = styled.div`
  padding: 20px;
`;

const TagCategory = styled.div`
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
`;

const TagCategoryWrapper = styled.div`
  margin-bottom: 10px;
  border-radius: 10px;
  overflow: hidden;
`;

const TagCategoryName = styled.div`
  font-weight: bold;
`;

const TagWrapper = styled.div`

`;

const FilterOption = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 10px;
  &:hover {
    background: whitesmoke;
  }
`;

const Name = styled.div`
  flex: 1;
  font-size: 16px;
`;

const CheckboxWrapper = styled.div`
  width: 20px;
`;

const FilterTagsWrapper = styled.div`
  margin-bottom: 10px;
`;

@observer
class WorksheetFilterOptions extends React.Component {
  @observable showSpinner = false;
  @observable tagIds = '';
  @observable progressTags = '';
  updateTimeout = null;

  constructor(props) {
    super(props);
    this.showSpinner = true;
    autorun(() => {
      if (!AppUI.loadingUser) {
        if (this.props.isExerciseFilter) {
          this.tagIds = AppUI.cookieStore.exerciseTagIds || '';
          this.progressTags = AppUI.cookieStore.exerciseProgressTags || '';
        } else {
          this.tagIds = AppUI.cookieStore[`worksheetTagIds${this.props.activeView}`] || '';
          this.progressTags = AppUI.cookieStore[`worksheetProgressTags${this.props.activeView}`] || '';
        }
      }
    });
  }
  debouncedUpdate = (isExercise, stringValue, isProgressTag = false) => {
    if (this.updateTimeout) {
      clearTimeout(this.updateTimeout);
    }

    this.updateTimeout = setTimeout(() => {
      if (isExercise) {
        if (isProgressTag) {
          AppUI.cookieStore.set('exerciseProgressTags', stringValue || null);
        } else {
          AppUI.cookieStore.set('exerciseTagIds', stringValue || null);
        }
      } else {
        if (isProgressTag) {
          AppUI.cookieStore.set(`worksheetProgressTags${this.props.activeView}`, stringValue || null);
        } else {
          AppUI.cookieStore.set(`worksheetTagIds${this.props.activeView}`, stringValue || null);
        }
      }
      if (isFunction(this.props.onUpdateFilter)) {
        this.props.onUpdateFilter();
      }
    }, 700);
  }
  onClickTag = (tagId) => {
    let ary = isPresent(this.tagIds) ? this.tagIds.split(',') : [];
    if (this.tagIsSelected(tagId)) {
      ary = ary.filter(item => item !== tagId);
    } else {
      ary.push(tagId);
    }
    const stringValue = ary.join(',');
    this.tagIds = stringValue;
    this.debouncedUpdate(this.props.isExerciseFilter, stringValue);
  }
  tagIsSelected = (tagId) => {
    return this.tagIds?.split(',')?.includes(tagId);
  }
  progressTagIsSelected = (tag) => {
    return isPresent(this.progressTags) && this.progressTags.split(',')?.includes(tag.slug);
  }
  onClickProgressTag = (tag) => {
    let ary = isPresent(this.progressTags) ? this.progressTags.split(',') : [];
    if (this.progressTagIsSelected(tag)) {
      ary = ary.filter(item => item !== tag.slug);
    } else {
      ary.push(tag.slug);
    }
    const stringValue = ary.join(',');
    this.progressTags = stringValue;
    this.debouncedUpdate(this.props.isExerciseFilter, stringValue, true);
  }

  render() {
    return (
      <Wrapper>
        <FilterTagsWrapper>
          <WorksheetFilterTags
            isExerciseFilter={this.props.isExerciseFilter}
            onUpdateFilter={this.props.onUpdateFilter}
            tagCategories={this.props.tagCategories}
            showProgressTag={this.props.showProgressTag}
            activeView={this.props.activeView}
            wrap
          />
        </FilterTagsWrapper>
        {
          this.props.tagCategories.filter(item => item.published).map(item => {
            if (item.slug === 'progress' && this.props.showProgressTag) {
              return (
                <TagCategoryWrapper
                  key={item.id}
                >
                  <TagCategory>
                    <TagCategoryName>
                      {item.name}
                    </TagCategoryName>
                  </TagCategory>
                  <TagWrapper>
                    {
                      item.tags.map(tag => {
                        return (
                          <FilterOption
                            key={tag.id}
                            onClick={() => this.onClickProgressTag(tag)}
                          >
                            <Name>
                              {tag.name}
                            </Name>
                            <CheckboxWrapper>
                              <Checkbox
                                value={this.progressTagIsSelected(tag)}
                              />
                            </CheckboxWrapper>
                          </FilterOption>
                        );
                      })
                    }
                  </TagWrapper>
                </TagCategoryWrapper>
              );
            } else if (item.slug !== 'progress') {
              return (
                <TagCategoryWrapper
                  key={item.id}
                >
                  <TagCategory>
                    <TagCategoryName>
                      {item.name}
                    </TagCategoryName>
                  </TagCategory>
                  <TagWrapper>
                    {
                      item.tags.filter(item => item.published).map(tag => {
                        return (
                          <FilterOption
                            key={tag.id}
                            onClick={() => this.onClickTag(tag.id)}
                          >
                            <Name>
                              {tag.name}
                            </Name>
                            <CheckboxWrapper>
                              <Checkbox
                                value={this.tagIsSelected(tag.id)}
                              />
                            </CheckboxWrapper>
                          </FilterOption>
                        );
                      })
                    }
                  </TagWrapper>
                </TagCategoryWrapper>
              );
            }
            return null;
          })
        }
      </Wrapper>
    );
  }
}

export default ErrorBoundary(WorksheetFilterOptions);
